import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/basic-ads/campaigns{/campaignId}{/get}{/action}/`,
  {},
  {
    updateCampaign: { method: 'PUT' },
    getStats: { method: 'GET', params: { get: 'stats' } },
    getReports: { method: 'GET', params: { get: 'reports' } },
    saveCSV: { method: 'GET', params: { get: 'stats', action: 'export' } },
  },
  {
    transformToCamelCase: true,
  },
);
